import { render } from "./App.vue?vue&type=template&id=f0ff52aa"
const script = {}

import "./App.vue?vue&type=style&index=0&id=f0ff52aa&lang=scss"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__